export default __webpack_public_path__ + "static/david60-070a87398b480b2bf30a5c4573120939.png";